<style lang="scss">
img{
    vertical-align: middle;
    height: 16px;
}
.receive-title{
    line-height: 36px;
    border-bottom: 1px solid #dedede;
    margin-bottom: 16px;
    padding-left: 20px;
    background-color: #19be6b;
    color: #fff;
}
.receive .ivu-select-dropdown{
    max-height:200px !important
}
</style>

<template> 
   <div class="bg-fff shadow margin-top-20 receive">
        <header class="receive-title font-bold">收货信息</header>
        <Form :label-width="120" :model="formData" class="margin-15 clearfix">
            <Col span="24">
                <Col span="12">
                    <FormItem v-if="alltype == 'query'" label='收件人'>
                        <span class="font-weight">{{comReceive.shippingName}}</span>
                    </FormItem>
                    <FormItem v-else label='收件人' :rules="required" prop="shippingName">
                        <Input v-model="formData.shippingName"></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem v-if="alltype == 'query'" label='国家编码'>
                        <span class="font-weight">{{comReceive.countryCode}}</span>
                    </FormItem>
                    <FormItem v-else label='国家编码' :rules="required" prop="countryCode">
                        <Select v-model="formData.countryCode" filterable clearable @on-change="oneCountry(formData.countryCode,'edit')">
                            <Option v-for="item in countries" :value="item.code" :key="item.id">{{ item.code }} ( {{item.nameEn}} )</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem v-if="alltype == 'query'" label='收货地址'>
                        <span class="font-weight">{{comReceive.addressline}}</span>
                    </FormItem>
                    <FormItem v-else label='收货地址' :rules="required" prop="addressline">
                        <Input v-model="formData.addressline"></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem v-if="alltype == 'query'" label='邮编'>
                        <span class="font-weight">{{comReceive.postalCode}}</span>
                    </FormItem>
                    <FormItem v-else label='邮编' :rules="required" prop="postalCode">
                        <Input v-model="formData.postalCode"></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem v-if="alltype == 'query'" label='地址2'>
                        <span class="font-weight">{{comReceive.addressline2}}</span>
                    </FormItem>
                    <FormItem v-if="alltype == 'edit'" label='地址2'>
                        <Input v-model="formData.addressline2"></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem v-if="alltype == 'query'" label='城市'>
                       <span class="font-weight">{{comReceive.city}}</span>
                    </FormItem>
                    <FormItem v-else label='城市' :rules="required" prop="city">
                       <Input v-model="formData.city"></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem v-if="alltype == 'query'" label='地址3'>
                        <span class="font-weight">{{comReceive.addressline3}}</span>
                    </FormItem>
                    <FormItem v-if="alltype == 'edit'" label='地址3'>
                        <Input v-model="formData.addressline3"></Input>
                    </FormItem>
                </Col>
                
                <Col span="12">
                    <FormItem v-if="alltype == 'query'" label='电话'>
                        <span class="font-weight">{{comReceive.phone}}</span>
                    </FormItem>
                    <FormItem  v-else label='电话'>
                        <Input v-model="formData.phone"></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem v-if="alltype == 'query'" label='州/省份'>
                        <span class="font-weight">{{comReceive.state}}</span>
                    </FormItem>
                    <FormItem v-else label='州/省份'>
                        <!-- <Select v-model="formData.state" filterable clearable ref="selectstate">
                            <Option v-for="item in states" :value="item.code?item.code:this.formData.state" :key="item.id">{{ item.code }} ({{item.nameEn}})</Option>
                        </Select> -->
                        <AutoComplete
                            v-model="formData.state"
                            :data="states"
                            :filter-method="filterMethod"
                            >
                        </AutoComplete>
                    </FormItem>
                </Col>
                <Col span="12" v-if="alltype == 'query'">
                    <FormItem  label='地址类型'>
                        <span class="font-weight">{{comReceive.addressType}}</span>
                    </FormItem>
                </Col>
            </Col>
        </Form>
    </div>
</template>

<script>
import { mapState,mapGetters } from 'vuex'
import { HttpGetStates } from '@/service/boss/b2corder'
import { HttpGetContry } from '@/service/boss/dictionary'
export default {
    props: ['comReceive', 'alltype', 'status', 'parentId'],
    data() {
        return {
            formData:{
                shippingName:"",
                countryCode:"",
                addressId:'',
                addressline:"",
                addressline2:'',
                addressline3:'',
                postalCode:"",
                city:"",
                phone:"",
                state:"",
                addressType:""
            },
            required: [{
                required: true,
                message: "该信息不能为空,请填写"
            }],    
            countries:[],
            states:[],
            type:this.$route.params.type,
        }
    },
    created() {
        this.handleDatas()
    },
    computed: {
        ...mapState('boss',['products']),
        ...mapGetters('boss',['warehouses']),
        
    },
    methods: {
        filterMethod (value, option) {
            return option.toLowerCase().indexOf(value.toLowerCase()) !== -1;
        },
        handleDatas(){
            let {shippingName, countryCode, addressId, addressline, addressline2, addressline3, postalCode, city, phone, state, addressType} = this.comReceive
            this.formData = {shippingName, countryCode, addressId, addressline, addressline2, addressline3, postalCode, city, phone, state, addressType}
            
            if(this.alltype=='edit'){
                this.oneCountry(this.comReceive.countryCode)
                this.getCountry()
            }
        },
        oneCountry(code,type){
            HttpGetContry({
                "search[EQ_depth]":2,
                "search[EQ_code]":code
            }).then(res=>{
                let onecode = res.data[0]
                this.getStates(onecode.id,type)
            },err=>{

            })
        },
        getCountry(){
            HttpGetContry({
                "search[EQ_depth]":2
            }).then(res=>{
                this.countries = res.data
            },err=>{

            })
        },
        getStates(code,type){
            if(type=='edit'){
                // this.$refs.selectstate.clearSingleSelect()
                this.formData.state=''
            }
            this.states = []
            HttpGetStates({
                "search[EQ_depth]":4,
                "search[EQ_parentId]":code
            }).then(res=>{
                let array = res.data
                array.map(item=>{
                    this.states.push(item.code)
                })
                // console.log(this.states)
            },err=>{

            })
        },
        // 数组去重
        arrayUnique(arr, name) {
            var hash = {};
            return arr.reduce((item, next)=>{
                hash[next[name]] ? '' : hash[next[name]] = true && item.push(next);
                return item;
            }, []);
        },
    },
    watch:{
        comReceive(){
            if(this.alltype != 'query'){
                this.handleDatas()
            }
        }
    }

}
</script>

